<template>
  <v-row v-if="kurumsalSevkiyat">
    <v-col cols="4">
      <div
        style="min-height: calc(50dvh - 24px); background-color: rgba(255, 180, 0, 0.25)"
        class="d-flex flex-column mb-6 pa-6 rounded-xl"
      >
        <div class="d-flex align-center mb-6">
          <v-avatar color="warning" size="48" class="me-4">
            <v-icon size="24" color="white">{{ icons.mdiTruck }}</v-icon>
          </v-avatar>
          <div class="text-h6 font-weight-bold warning--text">Sevkiyat Bilgilendirme</div>
        </div>
        <div class="flex-grow-1">
          <v-list color="transparent" class="pa-0" nav two-line>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon color="warning">{{ icons.mdiMinus }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle class="warning--text">
                  Anadolu Yakası Siparişleriniz
                </v-list-item-subtitle>
                <v-list-item-title>
                  <strong>{{ kurumsalSevkiyatYaziAnadolu }}</strong> günleri sevkedilir.
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider />
            <v-list-item>
              <v-list-item-avatar>
                <v-icon color="warning">{{ icons.mdiMinus }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle class="warning--text">
                  Avrupa Yakası Siparişleriniz
                </v-list-item-subtitle>
                <v-list-item-title>
                  <strong>{{ kurumsalSevkiyatYaziAvrupa }}</strong> günleri sevkedilir.
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
        <div>
          <v-btn class="text-capitalize" color="warning" to="order-approval" x-large rounded block
            >Bekleyen Siparişler</v-btn
          >
        </div>
      </div>

      <v-card rounded="xl" flat min-height="calc(50dvh - 128px)"> </v-card>
    </v-col>
    <v-col cols="8">
      <v-card rounded="xl" height="calc(100dvh - 128px)" flat>
        <v-card-title class="grey">
          <v-avatar color="primary" size="48" class="me-4">
            <v-icon size="24" color="white">{{ icons.mdiOrderNumericAscending }}</v-icon>
          </v-avatar>
          <div class="text-h6 font-weight-bold primary--text">Geçmiş Siparişler</div>
          <v-spacer />
          <v-btn rounded depressed class="text-capitalize" color="secondary" to="order-tracking"
            >Tüm Siparişler</v-btn
          >
        </v-card-title>

        <v-data-table
          :headers="siparisHeaders"
          :items="siparisItems"
          :items-per-page="5"
          hide-default-footer
          item-key="id"
          show-expand
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-0">
              <v-list color="" class="pa-0">
                <template v-for="(el, index) in item.products">
                  <v-list-item three-line :key="`item-${index}`">
                    <v-list-item-avatar
                      tile
                      :height="$vuetify.breakpoint.smAndUp ? 75 : 50"
                      :width="$vuetify.breakpoint.smAndUp ? 75 : 50"
                      color="white"
                      class="rounded-lg"
                    >
                      <v-avatar tile :height="60" :width="60">
                        <v-img
                          v-if="el.resim"
                          :src="$baseUrlAPI + '' + el.resim"
                          class="rounded-lg"
                        />
                        <v-icon v-else size="30" color="primary"> {{ icons.mdiCameraOff }}</v-icon>
                      </v-avatar>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>
                        <div class="text-caption mb-1">
                          <v-chip
                            label
                            :small="$vuetify.breakpoint.smAndUp"
                            :x-small="!$vuetify.breakpoint.smAndUp"
                            color="secondary"
                            style="font-size: 10px"
                            >{{ el.prd_code }}</v-chip
                          >
                        </div>
                        <div class="text-caption text-sm-subtitle-2 white--text">
                          {{ el.baslik }}
                        </div>
                        <div class="text-caption" v-if="$vuetify.breakpoint.smAndUp">
                          {{ el.kategori_path.split(",")[1] }}
                        </div>
                        <div v-else class="text-caption">
                          <span>
                            {{ Number(el.qty) }}
                            <span v-if="el.birim">
                              {{
                                $store.state.tanimlar.birim.find((ele) => ele.value === ele.birim)
                                  .text
                              }}
                            </span>
                            <span v-else>Tanımsız</span>
                          </span>
                          <span> - {{ el.total_price | currency }}</span>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                      <v-list-item-action-text>
                        {{ Number(el.qty) }}
                        <span v-if="el.birim">
                          {{
                            $store.state.tanimlar.birim.find((ele) => el.value === ele.birim).text
                          }}
                        </span>
                        <span v-else>Tanımsız</span>
                      </v-list-item-action-text>
                      <v-list-item-action-text>
                        <div class="text-overline white--text">
                          {{ el.total_price | currency }}
                        </div>
                      </v-list-item-action-text>
                    </v-list-item-action>
                  </v-list-item>

                  <v-divider v-if="item.products.length - 1 > index" :key="`divider-${index}`" />
                </template>
              </v-list>
            </td>
          </template>

          <!-- Sipariş Numarası -->
          <template #[`item.erporderno`]="{ item }">
            <v-chip
              label
              :color="item.erporderno === 'HATA' ? 'error' : 'grey'"
              class="d-flex justify-center text-caption"
            >
              <span
                class="text-caption text-xl-subtitle-2"
                style="letter-spacing: 0.5px; color: azure"
                >{{ item.erporderno }}</span
              >
            </v-chip>
          </template>
          <!-- Sipariş Başlık -->
          <template #[`item.adsoyad`]="{ item }">
            <div
              class="text-truncate"
              :style="
                $vuetify.breakpoint.lgAndDown
                  ? $vuetify.breakpoint.smAndDown
                    ? null
                    : 'max-width: 100px !important'
                  : 'max-width: 350px !important'
              "
            >
              <div class="text-caption text-lg-subtitle-2 white--text">
                {{ item.adsoyad }}
              </div>

              <div class="primary--text" style="font-size: 10px !important; line-height: 1.5">
                {{ item.cari_kod }}
              </div>
            </div>
          </template>
          <!-- Kalem Sayısı -->
          <template #[`item.kalem_sayisi`]="{ item }">
            <v-chip color="#9391a2" outlined class="d-flex justify-center" label>
              <div class="text-capitalize" style="text-align: center; font-size: 11px !important">
                {{ item.products.length }} Adet
              </div>
            </v-chip>
          </template>
          <!-- Sipariş Tarihi -->
          <template #[`item.siparis_tarihi`]="{ item }">
            <v-tooltip color="chip" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip color="" class="d-flex justify-center" label v-bind="attrs" v-on="on">
                  <div
                    class="text-truncate d-flex align-center"
                    style="
                      width: 130px !important;
                      text-align: center;
                      font-size: 11px !important;
                      letter-spacing: 0.5px;
                      color: azure;
                    "
                  >
                    <v-icon color="" small class="mr-2">
                      {{ icons.mdiCalendarClock }}
                    </v-icon>
                    <div class="mr-1">
                      {{ item.siparis_tarihi | moment("DD.MM.YYYY ") }}
                    </div>

                    <span> - {{ item.siparis_tarihi | moment("HH:mm") }}</span>
                  </div>
                </v-chip>
              </template>
              <div>
                {{ item.siparis_tarihi | moment("DD MMMM dddd") }}
              </div>
            </v-tooltip>
          </template>
          <template #[`item.actions`]="{ item }">
            <v-btn
              @click="siparisTekrar(item.id)"
              depressed
              class="text-caption text-capitalize font-weight-bold"
              color="chip"
              >Yeniden Sipariş Ver</v-btn
            >
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
// Icons
import { mdiTruck, mdiMinus, mdiOrderNumericAscending, mdiCalendarClock } from "@mdi/js";
import { computed, onMounted, ref } from "vue-demi";
import { postData, querySearch } from "@utils";
import store from "@/store";
import Vue from "vue";
const userData = JSON.parse(localStorage.getItem("userData"));

export default {
  setup() {
    const kurumsalSevkiyat = ref(false);
    onMounted(() => {
      if (userData.role === "COMM" || userData.role === "COMUSR") {
        kurumsalSevkiyat.value = true;
      } else {
        kurumsalSevkiyat.value = false;
      }
     // lastOrder();
    });
    const siparisHeaders = ref([
      {
        text: "Kalem",
        sortable: false,
        value: "kalem_sayisi",
        width: 80,
        sortable: false,
      },
      {
        text: "Sipariş No",
        sortable: false,
        value: "erporderno",
        width: 130,
      },
      {
        text: "Sipariş Tarihi",
        sortable: false,
        value: "siparis_tarihi",
        width: 130,
      },
      {
        text: "Cari Bilgileri",
        value: "adsoyad",

        sortable: false,
      },

      { text: "", sortable: false, value: "actions", align: "right" },
    ]);
    const siparisItems = ref([]);

    const lastOrder = async () => {
      postData({ method: "getSales" }).then((data) => {
        siparisItems.value = data.response.result;
      });
    };

    const siparisTekrar = (id) => {
      postData({
        method: "repeatOrderById",
        id,
      }).then((response) => {
        if (response.error == 1) {
          Vue.swal({
            title: "Hata",
            text: response.msg,
            width: "350px",
            icon: "error",
            background: "#FF4C51",
            showCloseButton: false,
            showConfirmButton: true,
            confirmButtonColor: "#cc3d41",
          });
          return;
        }
        store.dispatch("app-order/fetchBasketItemCount");
        store.commit("app/TOGGLE_BASKET_DRAWER", true);
      });
    };
    const kurumsalSevkiyatYaziAnadolu = computed(() => {
      let result;
      if (userData.role === "COMM") {
        result = "Pazartesi, Çarşamba, Cumartesi";
      } else if (userData.role === "COMUSR") {
        result = "Pazartesi";
      }
      return result;
    });

    const kurumsalSevkiyatYaziAvrupa = computed(() => {
      let result;
      if (userData.role === "COMM") {
        result = "Salı, Perşembe ve Cumartesi";
      } else if (userData.role === "COMUSR") {
        result = "Salı";
      }
      return result;
    });

    return {
      kurumsalSevkiyat,
      kurumsalSevkiyatYaziAnadolu,
      kurumsalSevkiyatYaziAvrupa,
      siparisHeaders,
      siparisItems,
      siparisTekrar,
      icons: {
        mdiTruck,
        mdiMinus,
        mdiOrderNumericAscending,
        mdiCalendarClock,
      },
    };
  },
};
</script>

<style></style>
